import React from 'react';
import '../../StylesCSS/ButtonsLayout.css';
import { School, Home, Input, ArrowBack } from '@mui/icons-material'; // Import des icônes
import { useNavigate } from 'react-router-dom'; // Import de useNavigate

const PageLayout3 = () => {
    const navigate = useNavigate(); // Initialisation de navigate

    const buttonStyle = {
        backgroundColor: '#33B5E6',
        color: 'white',
        padding: '10px 20px',
        margin: '10px 0',
        borderRadius: '8px',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '400px',
    };

    const buttonLeftStyle = {
        ...buttonStyle,
        backgroundColor: '#FF6347', // Couleur spécifique pour le bouton retour
    };

    return (
        <div style={{ maxWidth: '600px', margin: 'auto', textAlign: 'center' }}>
            <br></br>
            <div
          style={{
            display: "flex",
            justifyContent: "center", // Centrage horizontal
            alignItems: "center",

            backgroundColor: "#00B9B9",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            direction: "rtl",
            fontFamily: "Arial, sans-serif",
            fontSize: "22px",
            fontWeight: "bold",
            height: "80px",
            gap: "20px",
          }}
        >
          {/* Carré à droite (début de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>

          {/* Texte arabe centré */}
          <span>تدبير مجالس الأقســــام للجدع المشترك</span>

          {/* Carré à gauche (fin de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>
        </div>
        <br></br>
            <h2 style={{ textAlign: 'right' }}> : المحاضر</h2>
            <div className="buttons-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <button
                    className="btn btn-right"
                    onClick={() => navigate('/RepartitionDesElevesOrientesV2')}
                    style={buttonStyle}
                >
                    <School style={{ marginRight: '8px' }} />
                    توزيع التلاميد الموجهين حسب الاولى و الجنس و اللغة الاجنبية الثانية
                </button>

                <button
                    className="btn btn-right"
                    onClick={() => navigate('/EtudiantsInterieurVilleV2')}
                    style={buttonStyle}
                >
                    <Home style={{ marginRight: '8px' }} />
                    جدول ( ج ) مكرر
                </button>

                <button
                    className="btn btn-right"
                    onClick={() => navigate('/DistributionStudentsOutsideCityV2')}
                    style={buttonStyle}
                >
                    <Home style={{ marginRight: '8px' }} />
                    جدول ( ج )
                </button>
                <button
                    className="btn btn-right"
                    onClick={() => navigate('/TableAV2')}
                    style={buttonStyle}
                >
                    <Home style={{ marginRight: '8px' }} />
                    جدول ( أ )
                </button>

                <button
                    className="btn btn-right"
                    onClick={() => navigate('/ListeEtudiantsExclusV2')}
                    style={buttonStyle}
                >
                    <Home style={{ marginRight: '8px' }} />
                    لائحة التلاميذ المفصولين
                </button>
                 
                <button
                    className="btn btn-right"
                    onClick={() => navigate('/GradeScaleV2')}
                    style={buttonStyle}
                >
                    <Home style={{ marginRight: '8px' }} />
                 مدراج النقط
                </button>


                <button
                    className="btn btn-right"
                    onClick={() => navigate('/MinutesOfDepartmentCouncilDecisionV2')}
                    style={buttonStyle}
                >
                    <Input style={{ marginRight: '8px' }} />
                    محضر قرار مجلس القسم الخاص بالتوجيه
                </button>

                <button
                    className="btn btn-right"
                    onClick={() => navigate('/MinutesOfDepartmentCouncilDecision1V2')}
                    style={buttonStyle}
                >
                    <Input style={{ marginRight: '8px' }} />
                    محضر تقييم اشغال مجالس الاقسام الخاصة بالتوجيه
                </button>

                <button
                    className="btn btn-right"
                    onClick={() => navigate('/ResultatsDesConseilsV2')}
                    style={buttonStyle}
                >
                    <Input style={{ marginRight: '8px' }} />
                    النتائج العددية لمجالس الاقسام الخاصة بالتوجيه  للجدع المشترك
                </button>

                <button
                    className="btn btn-left"
                    style={buttonLeftStyle}
                    onClick={() => navigate('/PageLayoutVersion2')}
                >
                    <ArrowBack style={{ marginRight: '8px' }} />
                    Retour
                </button>
            </div>
        </div>
    );
};

export default PageLayout3;
